export type TransfersCardMode = 'recommended' | 'custom';

export type TransfersViewState =
  | 'loading'
  | 'error'
  | 'empty'
  | 'noFreeTransfers'
  | 'transfers'
  | 'adjustFilters';

type DeriveViewStateParams = {
  isLoading: boolean;
  isError: boolean;
  hasLoaded: boolean;
  hasTransfers: boolean;
  freeTransfers: number;
  remainingTransfers?: number;
  isUnlimited?: boolean;
  mode: TransfersCardMode;
};

export const deriveTransfersViewState = (
  params: DeriveViewStateParams
): TransfersViewState => {
  if (params.isError) return 'error';
  if (
    params.mode === 'recommended' &&
    params.remainingTransfers === 0 &&
    !params.isUnlimited
  ) {
    return 'noFreeTransfers';
  }
  if (params.isLoading || !params.hasLoaded) return 'loading';
  if (params.hasTransfers) return 'transfers';
  if (params.mode === 'custom' && !params.hasTransfers) return 'adjustFilters';
  return 'empty';
};

export const isTransfersVisible = (state: TransfersViewState): boolean =>
  state === 'transfers';

export const isLoadingState = (state: TransfersViewState): boolean =>
  state === 'loading';

export const isErrorState = (state: TransfersViewState): boolean =>
  state === 'error';

export const isEmptyState = (state: TransfersViewState): boolean =>
  state === 'empty';

export const isNoFreeTransfersState = (state: TransfersViewState): boolean =>
  state === 'noFreeTransfers';
